import { useConfigsByType } from '@features/configs/hooks/use-configs-by-type';

import { CAMPAIGN_CONFIG_TYPE, Campaign, toCampaign } from '../services/campaigns';

/**
 * Lists every campaign, backed by the shared configs-by-type query.
 * Returns the mapped campaigns alongside the underlying query state.
 */
export function useCampaigns() {
  const query = useConfigsByType(CAMPAIGN_CONFIG_TYPE);
  const campaigns: Campaign[] = (query.data?.items ?? []).map(toCampaign);

  return { ...query, campaigns };
}
